import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import type {
  FundraiserScenario,
  PlatformComparisonResult,
  PricingSourceOpen,
} from '../../models/fundraising-comparison.models';
import { evidenceBadgeClasses } from '../../data/evidence-presentation';

@Component({
  standalone: true,
  selector: 'app-calculation-details',
  imports: [CommonModule],
  templateUrl: './calculation-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalculationDetailsComponent {
  @Input({ required: true }) result!: PlatformComparisonResult;
  @Input({ required: true }) scenario!: FundraiserScenario;
  @Input() presentation: 'disclosure' | 'expanded' = 'disclosure';
  @Input() summaryLabel = 'View details';
  @Output() detailsOpened = new EventEmitter<string>();
  @Output() pricingSourceOpened = new EventEmitter<PricingSourceOpen>();

  onToggle(event: Event): void {
    const details = event.target as HTMLDetailsElement;
    if (details.open) {
      this.detailsOpened.emit(this.result.platformId);
    }
  }

  onPricingSourceOpened(sourceId: string): void {
    this.pricingSourceOpened.emit({
      platformId: this.result.platformId,
      sourceId,
    });
  }

  evidenceBadgeClasses = evidenceBadgeClasses;

  get donationCount(): number {
    return this.scenario.transactions.length;
  }

  get averageDonationCents(): number {
    return this.donationCount > 0
      ? Math.round(this.scenario.intendedGiftTotalCents / this.donationCount)
      : 0;
  }

  get primaryFeeLineItems() {
    return this.result.feeLineItems.filter(
      (item) => item.includedInPrimaryResult,
    );
  }

  formatMoney(amountCents: number): string {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amountCents / 100);
  }
}
